import {Mapper} from '@s-ui/domain'

export class FromUserConsentsStatusUserValueObjectToHttpUpdateConsentsRequestBodyMapper extends Mapper {
  #userConsents

  constructor({config}) {
    super()
    this.#userConsents = config.get('user').USER_CONSENTS
  }

  static create({config}) {
    return new FromUserConsentsStatusUserValueObjectToHttpUpdateConsentsRequestBodyMapper({config})
  }

  map = (userConsentsStatusUserValueObject = {}) => {
    const userConsentsStatus = userConsentsStatusUserValueObject.consents || []

    const consents = userConsentsStatus
      .map(consent => {
        return {name: consent.key, isGranted: consent.status}
      })
      .filter(consent => Object.values(this.#userConsents).includes(consent.name))

    // temporarily updating only FINANCIAL_SERVICES and WHATSAPP_COMMUNICATIONS_C2B consents due to side-effects

    return {consents}
  }
}
